 document.addEventListener('DOMContentLoaded', function() {
    const carouselNavs = document.querySelectorAll('carousel-navigation2');
    
    carouselNavs.forEach(nav => {
      const prevBtn = nav.querySelector('.product-gallery__arrow--prev');
      const nextBtn = nav.querySelector('.product-gallery__arrow--next');
      const carouselId = nav.getAttribute('aria-controls');
      const carousel = document.getElementById(carouselId);

      if (!carousel) return;
      const mediaItems = carousel.querySelectorAll('.product-gallery__media');
      let currentIndex = 0;
      mediaItems.forEach((item, idx) => {
        if (item.classList.contains('is-initial') || item === carousel.querySelector('[aria-current="true"]')) {
          currentIndex = idx;
        }
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          currentIndex = currentIndex > 0 ? currentIndex - 1 : mediaItems.length - 1;
          scrollToMedia(currentIndex);
        });
      }

      // Next button
      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          currentIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : 0;
          scrollToMedia(currentIndex);
        });
      }

      function scrollToMedia(index) {
        const media = mediaItems[index];
        if (media && !media.hidden) {
          media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          currentIndex = index;
        }
      }
    });
  });


document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.querySelector(".header-search__input");
  const defaultPanel = document.querySelector(".predictive-search__default");
  const predictiveSearch = document.querySelector("predictive-search");

  if (!searchInput || !defaultPanel || !predictiveSearch) return;


  searchInput.addEventListener("input", () => {
    if (searchInput.value.trim().length > 0) {
      defaultPanel.style.display = "none";
    } else {
      defaultPanel.style.display = "block";
    }
  });


  predictiveSearch.addEventListener("predictive-search:render", () => {
    defaultPanel.style.display = "none";
  });


  searchInput.addEventListener("focus", () => {
    if (searchInput.value.trim().length === 0) {
      defaultPanel.style.display = "block";
    }
  });

  document.addEventListener("click", (e) => {
    if (!searchInput.contains(e.target) && !predictiveSearch.contains(e.target)) {
      defaultPanel.style.display = "none";
    }
  });
});

